<div class="card">
    <h1 mat-dialog-title>{{ title }}</h1>
    <div mat-dialog-content>
        <br />
        <p [innerHTML]="text"></p>
    </div>
    <div mat-dialog-actions>
        <button class="text-danger" mat-button [mat-dialog-close]="false" cdkFocusInitial>
            {{ 'GENERAL.no' | translate }}
        </button>
        <button class="text-success" mat-button [mat-dialog-close]="true">{{ 'GENERAL.yes' | translate }}</button>
    </div>
</div>
